/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompetenceViewModel } from "../types/CompetenceViewModel.ts";

export const competenceViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da competência.")),
  name: z
    .string()
    .describe("Nome da competência, resolvido para o idioma solicitado.")
    .nullish(),
  description: z
    .string()
    .describe("Descrição da competência no idioma solicitado. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe("Idioma (cultura) da descrição retornada.")
    .nullish(),
}) as unknown as ToZod<CompetenceViewModel>;
